export default __webpack_public_path__ + "static/media/1899.eb4b813e.png";